import { useState } from "react";
import Swal from 'sweetalert2';
import "../assets/css/loading.css";

const initialState = {
  name: "",
  phone: "",
  email: "",
  service: "",
  message: "",
};

export const Contact = (props) => {
  const [formData, setFormData] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false); // Loading state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Start loading

    try {
      const response = await fetch('https://infrasoft.co.ke/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      // Check if the response is JSON
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        const result = await response.json();
        if (result.success) {
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Email sent successfully!',
          });
          setFormData(initialState);
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: `Failed to send email: ${result.error}`,
          });
        }
      } else {
        // Handle non-JSON responses (e.g., HTML error pages)
        const text = await response.text();
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: `Unexpected response: ${text}`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: `Failed to send email: ${error.message}`,
      });
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  return (
    <div className="contact-container" id="contact">
      <div className="form-container">
        <h2>Contact Us</h2>
        <p>Fill out the form below and we will get back to you soon.</p>
        <form onSubmit={handleSubmit}>
          <label>Your Name</label>
          <input
            type="text"
            name="name"
            placeholder="Enter Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <label>Your Phone</label>
          <input
            type="tel"
            name="phone"
            placeholder="Enter Your Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
          />

          <label>Your Email</label>
          <input
            type="email"
            name="email"
            placeholder="Enter Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <label>Select Service</label>
          <select
            name="service"
            value={formData.service}
            onChange={handleChange}
            required
          >
            <option value="">— Please choose an option —</option>
            <option value="Infrastructure Solutions">Infrastructure Solutions</option>
            <option value="Software Solutions">Software Solutions</option>
            <option value="Cloud Services">Cloud Services</option>
            <option value="Mobility Solutions">Mobility Solutions</option>
            <option value="Managed IT">Managed IT</option>
            <option value="IT Consultancy">IT Consultancy</option>
            <option value="Unified Communications">Unified Communications</option>
          </select>

          <label>Message</label>
          <textarea
            name="message"
            placeholder="Enter your message"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>

          <button type="submit" disabled={isLoading}>
            {isLoading ? (
              <div className="spinner"></div> // Loading spinner
            ) : (
              'Enquire Now'
            )}
          </button>
        </form>
      </div>

      <div className="info-container">
        <h3>Get In Touch</h3>
        <p>
          If you are searching for a proven way to accelerate your business and reach the pinnacle of your niche, contact us at Infrasoft Solutions Limited. We would be pleased to discuss your business’s needs and goals for the future, and create a strategy to get you there.
        </p>
        <div className="contact-btns">
          <div className="button-container">
            <a href="#" className="custom-btn">Get Quote</a>
            <a href="#" className="custom-btn">Book Demo</a>
          </div>
        </div>
      </div>
    </div>
  );
};